import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { isAuthenticated, validateSession } from "../lib/auth";

/**
 * A stored session renders at once while /auth/me checks the token silently: a
 * 401 clears it and redirects to /login, any other failure keeps the user in.
 */
export function RequireAuth() {
  const [authed, setAuthed] = useState(() => isAuthenticated());

  useEffect(() => {
    if (!authed) return;
    let cancelled = false;
    void validateSession().then((ok) => {
      if (!cancelled && !ok) setAuthed(false);
    });
    return () => {
      cancelled = true;
    };
  }, [authed]);

  if (!authed) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}
